
import img1 from './images/tour-1.jpeg'
import img2 from './images/tour-2.jpeg'
import img3 from './images/tour-3.jpeg'
import img4 from './images/tour-4.jpeg'


export const pageLinks = [
    {
        id: 1,
        href: '#home',
        text: 'home'
    },
    {
        id: 2,
        href: '#about',
        text: 'about'
    },
    {
        id: 3,
        href: '#services',
        text: 'services'
    },
    {
        id: 4,
        href: '#tours',
        text: 'tours'
    }
]


export const socialLinks = [
    {
        id: 1,
        href: 'https://www.instagram.com',
        icon: 'fab fa-squarespace'
    },
    {
        id: 2,
        href: 'https://www.facebook.com',
        icon: 'fab fa-facebook'
    },
    {
        id: 3,
        href: 'https://www.twitter.com',
        icon: 'fab fa-twitter'
    }
]


export const services = [
    {
        id: 1,
        icon: 'fas fa-wallet fa-fw',
        title: 'saving money',
        text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.'
    },
    {
        id: 2,
        icon: 'fas fa-wallet fa-fw',
        title: 'endless hiking',
        text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.'
    },
    {
        id: 3,
        icon: 'fas fa-wallet fa-fw',
        title: 'amazing comfort',
        text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, officia.'
    }



]



export const tours=[
    {
        id:1,
        title:'tibet adventure',
        img:img1,
        date:'august 26th, 2020',
        text:' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quod exercitationem fugit, qui corporis.',
        duration:'6 days',
        price:'from $2100',
        location:'china'

    },
      {
        id:2,
        title:'best of java',
        img:img2,
        date:'october 1th, 2020',
        text:' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quod exercitationem fugit, qui corporis.',
        duration:'11 days',
        price:'from $1400',
        location:'indonesia'

    },
    
  {
        id:3,
        title:'explore hong kong',
        img:img3,
        date:'september 15th,2020',
        text:' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quod exercitationem fugit, qui corporis.',
        duration:'8 days',
        price:'from $5000',
        location:'china'
    },
      {
        id:4,
        title:'kenya highlights',
        img:img4,
        date:'december 5th,2020',
        text:' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque vitae tempore voluptatum maxime reprehenderit eum quod exercitationem fugit, qui corporis.',
        duration:'20 days',
        price:'from $3300',
        location:'africa'

    },
    
    
]